'use client';
import React, { useState } from 'react';

export default function BrandStorySection() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const handlePlayVideo = () => {
    setVideoPlaying(true);
  };

  const stats = [
  { value: '6+', label: 'Products' },
  { value: '100%', label: 'Preservative-Free' },
  { value: '20g', label: 'Protein per 100g (Sattu)' },
  { value: '0g', label: 'Added sugar (Sugar-free)' }];


  return (
    <section id="about" className="pt-20 md:pt-28 pb-10 md:pb-14 overflow-hidden" style={{ background: 'var(--background)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top: About copy */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-16 md:mb-24 items-start">
          {/* Left */}
          <div className="reveal reveal-left">
            <span className="block text-[10px] uppercase tracking-[0.25em] mb-5" style={{ color: 'var(--accent-ink)' }}>
              About Kasturi
            </span>
            <h2
              className="font-display leading-none mb-8"
              style={{ fontSize: 'clamp(2.2rem, 5vw, 4rem)', fontWeight: 200, letterSpacing: '0.02em', color: 'var(--foreground)' }}>

              We go straight<br />
              to the{' '}
              <span className="italic font-light" style={{ color: 'var(--accent-ink)' }}>source.</span>
            </h2>

            {/* Stats row */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {stats?.map((s, i) =>
              <div
                key={s?.label}
                className={`p-4 rounded-2xl stagger-${i + 1}`}
                style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>

                  <p className="font-display font-[200] text-2xl md:text-3xl" style={{ color: 'var(--accent-ink)' }}>{s?.value}</p>
                  <p className="text-muted-foreground text-xs mt-1">{s?.label}</p>
                </div>
              )}
            </div>

            <a
              href="/about-us"
              className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider hover:gap-4 transition-all duration-300"
              style={{ color: 'var(--accent-ink)' }}>

              Read full story
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>

          {/* Right: Copy */}
          <div className="reveal reveal-right space-y-5 pt-4 lg:pt-16">
            <p className="text-foreground text-base leading-relaxed">
              Kasturi starts where good food starts – at the grain.
            </p>
            <p className="text-muted-foreground text-sm leading-relaxed">
              We source directly from farmers in Odisha, handpick what meets the Kasturi standard, and process everything in small and controlled batches. This intentional approach helps us deliver exceptional flavour and nutritional value, with every single pack.
            </p>
            <p className="text-muted-foreground text-sm leading-relaxed">
              No preservatives. No fillers. Just roasted grains, real nuts, and traditional recipes passed on Odia homes, through generations. Loaded with minerals and vitamins, each Kasturi product meets your daily micro-nutrient requirement and your body&apos;s requirements in an active lifestyle.
            </p>
            <p className="text-foreground text-base leading-relaxed font-semibold">
              Food that is rooted in tradition, and driven by nutrition.
            </p>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Chhatua, sattu and flours – every Kasturi product is lab-tested, FSSAI-certified, and poly-sealed fresh. Delivered as crafted, right from the mill to your kitchen.
            </p>

            {/* Divider with brand note */}
            <div className="pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground italic">
                &ldquo;A daily essential for your busy life.&rdquo; — Kasturi Food Products
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

}
export function BrandVideoSection() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const handlePlayVideo = () => setVideoPlaying(true);

  return (
    <section className="pt-6 pb-16 md:pb-24 overflow-hidden" style={{ background: 'var(--background)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal">
          <div className="mb-6 flex items-center justify-between">
            <div>
              <span className="block text-[10px] uppercase tracking-[0.25em] mb-2" style={{ color: 'var(--accent-ink)' }}>
                Watch
              </span>
              <h3 className="font-display text-xl md:text-2xl font-[200]" style={{ color: 'var(--foreground)' }}>
                Introducing Kasturi Chocolate Chhatua
              </h3>
            </div>
            <a
              href="https://www.youtube.com/channel/UC5JnFdZjwrI3Rj2zrB6i0DA"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex items-center gap-2 text-xs font-semibold uppercase tracking-wider hover:opacity-70 transition-opacity"
              style={{ color: 'var(--accent-ink)' }}>

              Our YouTube Channel
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 17L17 7M17 7H7M17 7v10" />
              </svg>
            </a>
          </div>

          {/* Video embed */}
          <div className="relative w-full rounded-2xl overflow-hidden" style={{ aspectRatio: '16/9', background: 'var(--foreground)' }}>
            {!videoPlaying ?
            <>
                {/* Thumbnail */}
                <img
                src="https://img.youtube.com/vi/XYLrTugDe9w/maxresdefault.jpg"
                alt="Watch Kasturi Foods Chocolate Chhatua product video"
                className="w-full h-full object-cover opacity-70" />

                {/* Dark scrim */}
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(26,18,8,0.6) 0%, transparent 60%)' }} />
                {/* Play button */}
                <button
                onClick={handlePlayVideo}
                className="absolute inset-0 flex items-center justify-center group"
                aria-label="Play Kasturi Chocolate Chhatua video">

                  <div
                  className="w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                  style={{ background: 'var(--accent)' }}>

                    <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--foreground)" className="ml-1">
                      <polygon points="5 3 19 12 5 21 5 3" />
                    </svg>
                  </div>
                </button>
                {/* Video title overlay */}
                <div className="absolute bottom-6 left-6 right-6">
                  <p className="text-white font-display text-lg md:text-2xl font-[200]">
                    Kasturi Chocolate Chhatua — A Daily Essential
                  </p>
                  <p className="text-white/60 text-sm mt-1">kasturifoodproducts · YouTube</p>
                </div>
              </> :

            <iframe
              src="https://www.youtube.com/embed/XYLrTugDe9w?autoplay=1&rel=0"
              title="Kasturi Chocolate Chhatua product video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full border-0"
              onLoad={() => setVideoLoaded(true)} />

            }
          </div>

          {/* Second video link */}
          <div className="mt-4 flex items-center gap-4">
            <a
              href="https://www.youtube.com/watch?v=IuC3eod0YZw"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-5 py-3 rounded-xl border transition-all duration-300 hover:border-primary group"
              style={{ borderColor: 'var(--border)', background: 'var(--card)' }}>

              <div className="w-8 h-8 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform" style={{ background: '#FF0000' }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="white">
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
              </div>
              <div>
                <p className="text-foreground text-xs font-semibold">Kasturi Chhatua — A Daily Essential for Your Busy Life</p>
                <p className="text-muted-foreground text-[10px] mt-0.5">Watch on YouTube</p>
              </div>
            </a>
          </div>

          <div className="mt-8 text-center">
            <a
              href="/products"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-bold uppercase tracking-wider transition-all duration-300 hover:opacity-90"
              style={{ background: 'var(--accent)', color: 'var(--accent-foreground)' }}>
              Explore Our Products
            </a>
          </div>
        </div>
      </div>
    </section>);
}
